import { Component, Input, OnInit } from '@angular/core';
import { EbwModalService } from '@ebw-monorepo/modal';
import { MtxGridColumn } from '@ng-matero/extensions/grid';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { take } from 'rxjs';
import { MapTableService } from '../../../services/map-table.service';
import { safeJsonParse, safeJsonStringify } from '@ebw-monorepo/microservices-helpers/utils/parser';
@Component({
  selector: 'ebw-monorepo-report-dialog-object-viewer',
  templateUrl: './report-dialog-object-viewer.component.html',
  styleUrls: ['./report-dialog-object-viewer.component.scss']
})
export class ReportDialogObjectViewerComponent implements OnInit {
  @Input() data: any[] = [];

  public dataGrid: any[] = [];
  public columnGrid: MtxGridColumn[] = [];

  constructor(private _transalteService: TranslateService, private _ebwModalService: EbwModalService, private _mapTableService: MapTableService) {}

  ngOnInit(): void {
    let tempColumnsGrid: MtxGridColumn[] = [];

    if (this.data && this.data.length > 0 && Object.keys(this.data[0]).includes('additional_info')) {
      this.data[0] = { ...this.data[0], ...this.data[0].additional_info };
      delete this.data[0].additional_info;
    }

    if (this.data.length > 0) {
      Object.keys(this.data[0]).forEach((key, index) => {
        const dataType = this._getDataType(this.data[0][key]);

        let formaterFn;
        let buttonsConf;

        let rowConf = {
          header: key,
          field: key,
          minWidth: 140
        };

        switch (dataType) {
          case 'date':
            formaterFn = (rowData) => {
              return moment(rowData[key]).format('DD/MM/yyyy');
            };
            break;
          case 'object':
            formaterFn = (rowData) => {
              return safeJsonStringify(rowData[key], '');
            };

            break;
          case 'attachment':
            buttonsConf = [
              {
                type: 'icon',
                text: '',
                icon: 'download',
                tooltip: 'Scarica allegato',
                color: 'accent',
                click: (rowData) => {
                  this._mapTableService
                    .downloadAttachment(rowData[key])
                    .pipe(take(1))
                    .subscribe({
                      next: (url: any) => {
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = `${rowData['name']}`;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                      },
                      error: (error: any) => {
                        this._ebwModalService.openErrorModal({
                          title: this._transalteService.instant('common.error'),
                          content: error.message != '' ? error.message : ''
                        });
                      }
                    });
                }
              }
            ];

            break;
          default:
            break;
        }

        if (formaterFn) {
          rowConf['formatter'] = formaterFn;
        }

        if (buttonsConf) {
          rowConf['type'] = 'button';
          rowConf['buttons'] = buttonsConf;
        }

        // decide the placement of the attachment download button and the name of the file
        if (dataType == 'attachment') {
          tempColumnsGrid.unshift(rowConf);
        } else if (key == 'name') {
          let attachment = tempColumnsGrid.findIndex((el) => {
            return el?.buttons && el.buttons[0].icon == 'download';
          });

          if (attachment) {
            tempColumnsGrid.splice(1, 0, rowConf);
          } else {
            tempColumnsGrid.unshift(rowConf);
          }
        } else {
          tempColumnsGrid.push(rowConf);
        }
      });

      this.columnGrid = tempColumnsGrid;
    }
  }

  public parseIfJson(val) {
    if (this._isJson(val)) {
      return safeJsonParse(val, val);
    }

    return val;
  }

  private _isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  private _getDataType(value): string {
    const filename = /\\([^\\]+)\.([^\\]+)$/;

    if (!value) {
      return null;
    }

    if (typeof value == 'string') {
      try {
        const isDate = moment(value);
        if (isDate.isValid()) {
          return 'date';
        }
      } catch (error) {}

      const match = filename.exec(value);

      if (match) {
        return 'attachment';
      }

      return 'string';
    }
    return typeof value;
  }
}
